import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/app/layout.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Advertising/AutoNative/AutoNative.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Advertising/Ada/Ada.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Advertising/Outbrain/Outbrain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Advertising/Prodo/Prodo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/boundaries/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/DarkLightModeToggle/DarkLightModeToggle.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedDataWrapper/EmbedDataWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedDefault/EmbedDefault.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedHtml/EmbedHtml.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedOpinary/EmbedOpinary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedSocial/EmbedSocial.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/IFrameResizer/IFrameResizer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Image/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/InfoGraphic/InfoGraphicSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/PushButton/PushButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/PushPopup/PushPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/scripts/GlobalScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/ScrollToTop/ScrollToTop.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/SectionTitle/SectionTitle.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Link/Link.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/ShareBtn/ShareBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Sidebar/Trigger/SidebarTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Teaser/Teaser.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Typography/Typography.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AccountProvider"] */ "/builds/publishing/ntvde-sport/web/frontend/src/context/AccountContextDpv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentProvider"] */ "/builds/publishing/ntvde-sport/web/frontend/src/context/ConsentContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaDataProvider"] */ "/builds/publishing/ntvde-sport/web/frontend/src/context/MetadataContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushProvider"] */ "/builds/publishing/ntvde-sport/web/frontend/src/context/PushContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/context/SidebarContext.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/groups/Wrapper/Testing/WrapperTesting.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/AdSlot/AdSlot.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailFooter/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailFooterItemDay/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailHead/Infos/ArticleDetailHeadInfos.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Gallery/Gallery.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/iFrame/Default/iFrameDefault.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/iFrame/InFront/iFrameInFront.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Integration/Sport/IntegrationSport.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Integration/TVProgram/IntegrationTVProgram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Menu/Header/Default/AccountBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Menu/Header/Default/SidebarTriggerBtn.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Menu/Sidebar/MenuSidebarDefault.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Push/History/PushHistory.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Push/TagList/PushTagList.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Infinity/TeaserInfinity.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Slider/TeaserSlider.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/TopicBox/TopicBox.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Video/VideoDefault.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Video/VideoInline.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Video/VideoInlineTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/ntvde-sport/web/frontend/src/error/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/libs/bugsnag/bugsnag.client.ts");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedPodcast/EmbedPodcast.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/RTLMusic/RTLMusicInline.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/InfoGraphic/InfoGraphic.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/InfoBox/InfoBoxInline.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedChess/EmbedChess.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedDarts/EmbedDarts.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedGoogleMap/EmbedGoogleMap.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/embeds/EmbedWeather/EmbedWeather.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/AdLabel/AdLabel.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/ShopTeaser/ShopTeaser.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/external/ExternalInline.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Affiliate/AffiliateInline.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Gallery/GalleryInline.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Gallery/GalleryDefault.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Picture/Picture.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Breadcrumb/BreadcrumbDefault.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Banner/BannerDefault.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Menu/Footer/MenuFooter.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/AppButton/AppButton.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/components/Title/Title.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Integration/Weather/IntegrationWeather.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Menu/Header/TabNavigation/MenuHeaderTabNavigation.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Menu/Header/Navigation/MenuHeaderNavigation.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Menu/Header/Default/MenuHeaderDefault.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/dpa/Default/DPADefault.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Inline/TeaserInline.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Small/TeaserSmall.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/components/TypeVisualizer/TypeVisualizer.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Highlight/_3/TeaserHighlight_3.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Highlight/TeaserHighlight.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Highlight/_1/TeaserHighlight_1.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Teaser/Highlight/_2/TeaserHighlight_2.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailHeadItemDay/ArticleDetailHeadItemDay.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailHead/Intro/ArticleDetailHeadIntro.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailHeadDay/ArticleDetailHeadDay.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineGoogleMap/StorylineGoogleMap.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineOpinary/StorylineOpinary.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineListNumbered/StorylineListNumbered.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineEmbed/StorylineEmbed.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineTable/StorylineTable.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineListBulleted/StorylineListBulleted.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineParagraph/StorylineParagraph.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineLeadText/StorylineLeadText.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/StorylineSubHeadline/StorylineSubHeadline.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/CitationBox/CitationBox.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/Author/Author.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/widgets/Article/ArticleDetailDefault/StorylineElements/ClickPic/ClickPic.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/groups/Grid/Sidebar/GridSidebar.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/groups/Grid/Wrapper/GridWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/groups/Grid/Article/GridArticle.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/groups/Grid/ArticleCollection/GridArticleCollection.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/groups/Grid/Content/GridContent.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/src/elements/groups/Grid/Grid/GridGrid.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"IBM_Plex_Sans_Condensed\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"preload\":true,\"fallback\":[\"system-ui\",\"-apple-system\",\"Segoe UI\",\"Roboto\",\"Helvetica\",\"Arial\",\"sans-serif\"],\"variable\":\"--ibm-plex-sans-condensed\"}],\"variableName\":\"fontIBM\"}");
;
import(/* webpackMode: "eager" */ "/builds/publishing/ntvde-sport/web/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Bebas_Neue\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"weight\":\"400\",\"fallback\":[\"system-ui\",\"-apple-system\",\"Segoe UI\",\"Roboto\",\"Helvetica\",\"Arial\",\"sans-serif\"],\"variable\":\"--bebas-neue\"}],\"variableName\":\"fontBebas\"}");
